/* ============================================================================
   UpCart subscription guard
   ----------------------------------------------------------------------------
   Rule: a product can only be SUBSCRIBED when its total quantity in the cart is
   at least MIN_SUB_QTY (2). (A product's flavors all count toward that total.)

   What it does:
     1. Hides UpCart's "subscription upgrade" button on any line whose product
        has a total quantity below the minimum (so a single-qty product can't
        be subscribed at all). The button reappears once the product reaches 2.
     2. After any cart change, corrects the state:
          • a subscribed product under the minimum but with total qty >= 2 has
            its one-time sibling lines upgraded to the same plan (so the whole
            product becomes subscribed);
          • a subscribed product that can't reach the minimum is reverted to a
            one-time purchase.
     3. Keeps UpCart's checkout button DISABLED for the whole correction window,
        so there is no gap to check out with a bad subscription.

   Debug: add ?pg_subguard_debug to the URL (or window.PG_SUBGUARD_DEBUG).
   ============================================================================ */
(function () {
  'use strict';

  // Skip the native cart-drawer page (subscription PDP) — it enforces the rule
  // itself and interfering mid-build could break it.
  var bodyCls = document.body ? document.body.className : '';
  if (/use-new-cart-drawer|pdp-subscription/.test(bodyCls)) return;

  var MIN_SUB_QTY    = 2;
  var MAX_PASSES     = 8;
  var NOTICE_REVERT  = 'Subscriptions need at least 2 — switched to one-time.';
  var NOTICE_UPGRADE = 'Both flavors added to your subscription.';
  var BUSY_TEXT      = 'One moment — updating your cart…';
  var DEBUG = /pg_subguard_debug/.test(location.search) || window.PG_SUBGUARD_DEBUG;

  var fixing = false, passes = 0, busy = false, noticeTimer = null;
  var lastCart = null, obs = null, renderT = null;

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, ['[subguard]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  /* ---------- notice toast (main document) ---------- */
  function showNotice(msg) {
    var el = document.getElementById('pg-subguard-notice');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pg-subguard-notice';
      el.setAttribute('role', 'status');
      el.style.cssText = [
        'position:fixed','left:50%','bottom:24px','transform:translateX(-50%) translateY(12px)',
        'max-width:calc(100vw - 32px)','z-index:2147483647','box-sizing:border-box',
        'padding:12px 18px','border-radius:10px','background:#1B2030','color:#F4F1EA',
        'font-family:-apple-system,Segoe UI,Roboto,sans-serif','font-size:14px','line-height:1.35',
        'text-align:center','box-shadow:0 10px 30px rgba(0,0,0,0.28)','opacity:0','pointer-events:none',
        'transition:opacity 200ms ease, transform 200ms ease'
      ].join(';');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    void el.offsetWidth;
    el.style.opacity = '1';
    el.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(12px)';
    }, 4000);
  }

  /* ---------- UpCart shadow-DOM rendering (checkout lock + hide upgrade) ---------- */
  function upcartRoot() {
    var host = document.querySelector('#upCart');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function applyCheckoutLock(root) {
    if (!root) return;
    root.querySelectorAll('.upcart-checkout-button, .upcart-checkout-button-container').forEach(function (el) {
      if (busy) {
        el.style.pointerEvents = 'none'; el.style.opacity = '0.55';
        el.setAttribute('aria-disabled', 'true'); if (el.tagName === 'BUTTON') el.disabled = true;
      } else {
        el.style.pointerEvents = ''; el.style.opacity = '';
        el.removeAttribute('aria-disabled'); if (el.tagName === 'BUTTON') el.disabled = false;
      }
    });
  }

  function applyUpgradeVisibility(root) {
    if (!root || !lastCart) return;
    var totalByProduct = {}, productOfVariant = {};
    (lastCart.items || []).forEach(function (it) {
      totalByProduct[it.product_id] = (totalByProduct[it.product_id] || 0) + (it.quantity || 0);
      productOfVariant[it.id] = it.product_id;                 // it.id === variant id
      if (it.variant_id) productOfVariant[it.variant_id] = it.product_id;
    });
    root.querySelectorAll('.upcart-public-component-product-tile').forEach(function (tile) {
      var btn = tile.querySelector('.upcart-public-component-product-tile__subscription-upgrade');
      if (!btn) return;
      var link = tile.querySelector('a[href*="variant="]');
      var vid = null;
      if (link) { var m = /variant=(\d+)/.exec(link.getAttribute('href') || ''); if (m) vid = parseInt(m[1], 10); }
      var pid = (vid != null) ? productOfVariant[vid] : null;
      var total = (pid != null) ? (totalByProduct[pid] || 0) : null;
      // Hide the upgrade button when this product can't yet be subscribed.
      btn.style.display = (total != null && total < MIN_SUB_QTY) ? 'none' : '';
    });
  }

  function render() {
    var root = upcartRoot();
    applyCheckoutLock(root);
    applyUpgradeVisibility(root);
  }
  function scheduleRender() { clearTimeout(renderT); renderT = setTimeout(render, 60); }

  function ensureObserver() {
    if (obs) return;
    var root = upcartRoot();
    if (!root) return;
    obs = new MutationObserver(scheduleRender);
    obs.observe(root, { childList: true, subtree: true });
    render();
  }

  function setBusy(state) {
    busy = state;
    render();
    log('busy =', busy);
  }

  // Hard guard: block checkout clicks during the busy window (shadow-DOM clicks
  // are composed, so they reach this capture listener).
  document.addEventListener('click', function (e) {
    if (!busy) return;
    var path = (e.composedPath && e.composedPath()) || [];
    var hit = path.some(function (n) {
      return n && typeof n.className === 'string' && /upcart[-_].*checkout|checkout-button/i.test(n.className);
    });
    if (hit) {
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      showNotice(BUSY_TEXT); log('blocked checkout click during busy window');
    }
  }, true);

  /* ---------- cart evaluation + correction ---------- */
  function sellingPlanId(it) {
    if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) {
      return it.selling_plan_allocation.selling_plan.id;
    }
    return it.selling_plan_id || null;
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }
  function changeLine(op) {   // op = { key, qty, selling_plan }  (null = one-time)
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: op.key, quantity: op.qty, selling_plan: op.selling_plan })
    }).then(function (r) { return r.json(); });
  }

  function enforce(reason) {
    if (fixing) return;
    fixing = true;
    setBusy(true);
    getCart().then(function (cart) {
      lastCart = cart;
      render();  // refresh button visibility against the fresh cart

      var prod = {};
      (cart.items || []).forEach(function (it) {
        var pid = it.product_id;
        if (pid == null) return;
        var p = prod[pid] || (prod[pid] = { total: 0, sub: 0, subPlan: null, subLines: [], oneTime: [] });
        p.total += (it.quantity || 0);
        var plan = sellingPlanId(it);
        if (plan) {
          p.sub += (it.quantity || 0);
          if (!p.subPlan) p.subPlan = plan;
          p.subLines.push({ key: it.key, qty: it.quantity || 0 });
        } else {
          p.oneTime.push({ key: it.key, qty: it.quantity || 0 });
        }
      });

      var ops = [], anyUpgrade = false, anyRevert = false;
      Object.keys(prod).forEach(function (pid) {
        var p = prod[pid];
        if (p.sub === 0) return;
        if (p.sub >= MIN_SUB_QTY) return;
        if (p.total >= MIN_SUB_QTY && p.subPlan) {
          p.oneTime.forEach(function (l) { ops.push({ key: l.key, qty: l.qty, selling_plan: p.subPlan }); anyUpgrade = true; });
        } else {
          p.subLines.forEach(function (l) { ops.push({ key: l.key, qty: l.qty, selling_plan: null }); anyRevert = true; });
        }
      });

      log('enforce(' + reason + ') ops=', ops.length, 'pass=', passes);

      if (!ops.length) { passes = 0; fixing = false; setBusy(false); return; }
      if (passes >= MAX_PASSES) { fixing = false; setBusy(false); log('max passes, releasing'); return; }

      passes += 1;
      showNotice(anyUpgrade && !anyRevert ? NOTICE_UPGRADE : NOTICE_REVERT);
      (function next(i) {
        if (i >= ops.length) {
          try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(true); } catch (e) {}
          fixing = false;
          setTimeout(function () { enforce('post-fix'); }, 250);
          return;
        }
        changeLine(ops[i]).then(function () { next(i + 1); }).catch(function () { next(i + 1); });
      })(0);
    }).catch(function (e) { log('getCart failed', e); fixing = false; setBusy(false); });
  }

  var schedule = (function () {
    var t = null;
    return function (reason) { setBusy(true); ensureObserver(); clearTimeout(t); t = setTimeout(function () { enforce(reason); }, 150); };
  })();

  /* ---------- triggers ---------- */
  ['cart-loaded', 'cart-updated', 'cart-changed', 'cart-refreshed'].forEach(function (n) {
    window.addEventListener('aftersell-upcart:public-events:' + n, function () { ensureObserver(); schedule('evt:' + n); });
  });
  try {
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var u = (typeof url === 'string') ? url : (url && url.url) || '';
      var isMutation = /\/cart\/(add|change|update|clear)(\.js|$|\?)/.test(u);
      var p = _fetch.apply(this, arguments);
      if (isMutation && p && p.then) { p.then(function () { schedule('fetch'); }); }
      return p;
    };
  } catch (e) { log('fetch patch failed', e); }
  try {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { if (/\/cart\/(add|change|update|clear)/.test(url)) { this.addEventListener('load', function () { schedule('xhr'); }); } } catch (e2) {}
      return _open.apply(this, arguments);
    };
  } catch (e) { log('xhr patch failed', e); }

  // Attach the observer as soon as UpCart's shadow root exists, and do an
  // initial evaluation.
  var tries = 0;
  (function boot() {
    ensureObserver();
    if (document.querySelector('#upCart')) { enforce('init'); return; }
    if (tries++ < 40) setTimeout(boot, 500);   // up to ~20s for UpCart to load
  })();

  log('loaded');
})();
